/**
 * Декоратор для пометки статических методов, которые должны быть
 * вызваны при инициализации runtime.
 *
 * @param priority - Приоритет выполнения. Больший приоритет = выполнится раньше.
 *                   По умолчанию 0.
 *
 * @example
 * ```ts
 * class RenderSystem {
 *   @runtimeInit(100) // Высокий приоритет - выполнится рано
 *   static init() {
 *     console.log("RenderSystem initialized");
 *   }
 * }
 *
 * class PhysicsSystem {
 *   @runtimeInit() // Приоритет 0
 *   static setup() {
 *     console.log("PhysicsSystem initialized");
 *   }
 * }
 * ```
 *
 * Затем в entry point:
 * ```ts
 * import "virtual:runtime-init"; // Автоматически вызовет все @runtimeInit методы
 * ```
 */
export function runtimeInit(_priority: number = 0): MethodDecorator {
  // Декоратор ничего не делает в runtime - это маркер для статического анализа
  return function (_target, _propertyKey, descriptor) {
    return descriptor;
  };
}
